module.exports = __webpack_public_path__ + "static/legala_screen-4aa89f9352f87bf84376eba0378f3c1d.jpg";